export default __webpack_public_path__ + "static/indoor22-fd12f044ea8d3d7ff3bf603b33ab2006.webp";